/**
 * Toggle Row and Text of CTA on click
 * @module toggleRow
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'toggleRow';
export const CLICK_HANDLER = 'click';
export const DEFAULTS = {};

/**
 * Add aria live attribute to targeted el
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [opts={}] - Any options provided upon initialization
 */

 const addClass = ($toggleBlock, className) => {
   $toggleBlock.addClass(className);
 };

 const removeClass = ($toggleBlock, className) => {
   $toggleBlock.removeClass(className);
 };

 const updateText = ($el, newText) => {
   $el.text(newText);
 }

 const toggleView = ($el, opts) => {
   const {
     container,
     toggleBlock,
     activeClass,
     updatedText,
     defaultText,
   } = opts;
   const $toggleBlock = $el.closest(container).find(toggleBlock);
   const hasClass = $toggleBlock.hasClass(activeClass);
   if (hasClass) {
     removeClass($toggleBlock, activeClass);
     updateText($el, defaultText);
   } else {
     addClass($toggleBlock, activeClass);
     updateText($el, updatedText);
   }
 };

 const setEventListeners = ($el, opts) => {
   $el.on(CLICK_HANDLER, evt => {
     evt.preventDefault();
     toggleView($el, opts);
   });
 };

/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function toggleRowInit(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, toggleRowInit);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/toggle-row.js